import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as prismic from '@prismicio/client';
import withPreview from '../../hoc/WithPreview/WithPreview';
import { prismicConfig } from '../../config';
import tmpl from './BlogPost.jsx';

const BlogPost = () => {
  const { uid } = useParams();
  const [doc, setDoc] = useState(null);
  const client = prismic.createClient(prismicConfig.apiEndpoint, {
    accessToken: prismicConfig.accessToken,
  });

  /**
   * Update when uid changes
   */
  useEffect(() => {
    fetchContent(uid);
  }, [uid]);

  /**
   * Fetch content from CMS
   */
  const fetchContent = async (uid) => {
    const document = await client.getByUID('blog_post', uid);
    // @TODO: Redirect to NotFound if no content available (uid is invalid)
    document
      ? setDoc(document)
      : console.log(
          `${this.constructor.name}: No content found for postId '${uid}'`
        );
  };

  return tmpl(doc);
};

export default withPreview(BlogPost);
